export default "__VITE_ASSET__DlsmPphc__"